var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { RecordSubType } from './RecordSubType';
import { RecordState } from './RecordState';
import { HistoryEntryRow } from './HistoryEntryRow';
import moment from 'moment';
var FrontPageTask = /** @class */ (function (_super) {
    __extends(FrontPageTask, _super);
    function FrontPageTask(task, i18n) {
        var _this = _super.call(this) || this;
        _this.i18n = i18n;
        Object.assign(_this, task);
        return _this;
    }
    Object.defineProperty(FrontPageTask.prototype, "displayTaskType", {
        get: function () {
            if (this.isAidProposal)
                return this.i18n.t("Forms.AidProposal").toString();
            if (this.isAidDecision)
                return this.i18n.t("Forms.AidDecision").toString();
            if (this.isPaymentBan)
                return this.i18n.t("Forms.PaymentBan").toString();
            if (this.isInvestmentDecision)
                return this.i18n.t("Forms.InvestmentDecision" + this.subTaskString).toString();
            if (this.isChangeRequestDecision)
                return this.i18n.t("Forms." + this.taskType + "Feedback").toString();
            var subject = this.i18n.t("Forms." + this.taskType + this.subTaskString).toString();
            var specification = this.i18n.t("Forms.Feedback").toString();
            return this.isFeedback
                ? specification + " - " + subject
                : subject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FrontPageTask.prototype, "isAidProposal", {
        get: function () {
            return this.state === RecordState.ProposalGiven;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FrontPageTask.prototype, "isAidDecision", {
        get: function () {
            return this.taskType === "AidApplication" && this.state === RecordState.DecisionGiven;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FrontPageTask.prototype, "isPaymentBan", {
        get: function () {
            return this.taskType === "PaymentBan";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FrontPageTask.prototype, "isInvestmentDecision", {
        get: function () {
            return this.taskType === "InvestmentReport" && this.state === RecordState.DecisionGiven;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FrontPageTask.prototype, "isInvestmentReport", {
        get: function () {
            return this.taskType === "InvestmentReport";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FrontPageTask.prototype, "isChangeRequestDecision", {
        get: function () {
            return (this.taskType === "DeadlineChange"
                || this.taskType === "PurposeChange"
                || this.taskType === "TargetChange")
                && this.state === RecordState.DecisionGiven;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FrontPageTask.prototype, "isRefundRequest", {
        get: function () {
            return (this.taskType === "RefundRequest"
                || this.taskType === "ClaimForRecovery");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FrontPageTask.prototype, "subTaskString", {
        get: function () {
            return this.taskSubType ? "." + RecordSubType[this.taskSubType] : "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FrontPageTask.prototype, "isPastDeadline", {
        get: function () {
            if (this.deadline) {
                var utcDeadline = moment.utc(this.deadline).toDate();
                var localDeadline = moment(utcDeadline).local();
                return !this.showDeadline || (moment().diff(localDeadline) < 0) ? false : true;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FrontPageTask.prototype, "showDeadline", {
        get: function () {
            return this.deadline != null && (!this.isFeedback || this.isAidDecision) && !this.isRefundRequest;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FrontPageTask.prototype, "arrivalOrCreatedDate", {
        get: function () {
            if (this.isFeedback)
                return this.latestActionDate;
            return this.recordCreatedDate;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FrontPageTask.prototype, "requiresAction", {
        get: function () {
            return !this.isPastDeadline && (this.isFeedback || this.state == RecordState.New);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FrontPageTask.prototype, "routeValue", {
        get: function () {
            var specification = this.isFeedback ? "Feedback" : "";
            switch (this.taskType) {
                case "OrganisationYearlyReport":
                    return "organisationYearlyReport" + specification;
                case "AidApplication":
                    if (this.isAidProposal)
                        return "aidProposal";
                    if (this.isAidDecision)
                        return "aidDecision";
                    return "aidApplication";
                case "AccountNumberRequest":
                    return "accountNumberRequest" + specification;
                case "AupReport":
                    return "aupReport";
                case "MaterialRequest":
                    return "materialRequest";
                case "ExpandedStrategyAndBudgetaryEstimate":
                    return "expandedsbe" + specification;
                case "PaymentPlan":
                    return "paymentPlan" + specification;
                case "PaymentRequestExpenseReport":
                    return "paymentRequestER" + specification;
                case "SummaryReport":
                    return "summaryReport" + specification;
                case "ContinuousReport":
                    return "continuousReport" + specification;
                case "ContinuousReportSummary":
                    return "continuousReportSummary";
                case "RefundRequest":
                    return "refundRequest" + specification;
                case "ClaimForRecovery":
                    return "claimForRecovery" + specification;
                case "PaymentBan":
                    return "paymentBan";
                case "AidTargetYearlyReport":
                    return "aidTargetYearlyReport" + specification;
                case "InvestmentReport":
                    if (this.isInvestmentDecision) {
                        return this.taskSubType === RecordSubType.InvestmentBudgetaryEstimate
                            ? "investmentBudgetaryEstimateFeedback"
                            : "investmentFinalReportFeedback";
                    }
                    return "investmentReport";
                case "DeadlineChange":
                    return "deadlineChange" + specification;
                case "PurposeChange":
                    return "purposeChange" + specification;
                case "TargetChange":
                    return "targetChange" + specification;
                case "GeneralNotification":
                    return "generalNotification";
                case "TransferredAmountNotification":
                    return "transferredAmountNotification";
                case "InspectionVisitNotification":
                    return "inspectionVisitNotification";
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    return FrontPageTask;
}(HistoryEntryRow));
export { FrontPageTask };
